export default {
  mapLeftClick: {
    'placeInfo': 'Detalles del local',
    'placeInsidePolygon': 'Local dentro del polígono',
    'polygonArea': 'Área del polígono',
    'copyLnglat': 'Copiar lng, lat',
    'copyLatlng': 'Copiar lat, lng',
    'directionsToClickedPoint': 'Haga clic en el botón de la ruta para iniciar una ruta hasta el punto pulsado en el mapa',
    'lnglatCopied': 'Longitud y latitud copiadas',
    'latlngCopied': 'Latitud y longitud copiadas'
  }
}
